module.exports = __webpack_public_path__ + "static/media/Poppins-Thin.ab051b9f.ttf";